import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b20431a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "state-list d-flex flex-wrap justify-content-center justify-content-sm-start mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "state-list-item me-1 mb-1"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-0" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Meldung")
  ]),
  /*#__PURE__*/_createElementVNode("button", {
    "data-bs-dismiss": "modal",
    "aria-label": "Close",
    class: "flycon flycon-top flycon-24 flycon-close text-dark bg-transparent lh-0 rounded-circle p-1 border-0 end-0 position-absolute me-1"
  })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "modal-body p-3 pb-0 modal-lg text-start"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-color--low-emphasis fw-normal fs-3" }, " Für welche Bundesländer wollen Sie Maßnahmen finden? ", -1))
const _hoisted_6 = { class: "form-check pb-2" }
const _hoisted_7 = ["id", "disabled", "checked", "value"]
const _hoisted_8 = ["for"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "modal-footer px-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterStatesAdd = _resolveComponent("FilterStatesAdd")!
  const _component_FilterStateCard = _resolveComponent("FilterStateCard")!
  const _component_CardBorderedBody = _resolveComponent("CardBorderedBody")!
  const _component_CardBordered = _resolveComponent("CardBordered")!
  const _component_FilterFooter = _resolveComponent("FilterFooter")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.itemsSelected === 0)
      ? (_openBlock(), _createBlock(_component_FilterStatesAdd, {
          key: 0,
          class: "mb-5"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state, index) => {
        return (_openBlock(), _createBlock(_component_FilterStateCard, {
          "state-item": state,
          key: index
        }, null, 8, ["state-item"]))
      }), 128)),
      (_ctx.itemsSelected > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.itemsSelected > 0)
              ? (_openBlock(), _createBlock(_component_FilterStatesAdd, {
                  key: 0,
                  title: _ctx.itemsSelected < 0,
                  class: _normalizeClass('card-wrapper--rectangle')
                }, null, 8, ["title"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Modal, { name: "stateListModal" }, {
      header: _withCtx(() => [
        _hoisted_3
      ]),
      body: _withCtx(() => [
        (_ctx.states)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_CardBordered, { wrapperClass: 'border-0 mx-n3 card-inner' }, {
                body: _withCtx(() => [
                  _createVNode(_component_CardBorderedBody, { wrapperClass: 'states-list' }, {
                    gridContent: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.states, (state, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "col-12 col-md-6 states-input-wrapper",
                          key: index
                        }, [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: 'validity-spatially-extracted-' + index,
                              disabled: !state.measuresExists,
                              checked: state.isActive,
                              value: state.id,
                              onChange: _cache[0] || (_cache[0] = ($event: any) => (
                        _ctx.updateSelectedItems(
                          $event.target.value,
                          $event.target.checked
                        )
                      ))
                            }, null, 40, _hoisted_7),
                            _createElementVNode("label", {
                              class: "form-check-label",
                              for: 'validity-spatially-extracted-' + index
                            }, _toDisplayString(state.label), 9, _hoisted_8)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_ctx.getPlaceholder()), 1)
            ]))
      ]),
      footer: _withCtx(() => [
        (_ctx.states)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_FilterFooter, {
                onDiscardFilterState: _ctx.discardFilterState,
                onSaveFilterState: _ctx.saveFilterState,
                saveButtonText: 'Maßnahmen anzeigen',
                "reset-button-visible": _ctx.itemsSelected !== 0,
                "used-on-modal": true
              }, null, 8, ["onDiscardFilterState", "onSaveFilterState", "reset-button-visible"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}